<template>
  <v-dialog
    v-model="show"
    width="500"
  >
    <v-card v-click-outside="clickOutside()" >
      <v-card-title v-if="title" class="title"
      >
        {{title}}
      </v-card-title>

      <v-card-text class="text">
        {{text}}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed class="button"
          v-for="button in buttons" :key="button.text"
          @click="triggerEvent(button.event)">
          {{ button.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'Dialog',

    props: {
      title: {
        type: String,
        required: false
      },
      text: {
        type: String,
        required: true
      },
      buttons: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      show: false
    }),

    methods: {
      openModal() {
        this.show = true;
      },
      triggerEvent(event) {
        this.show = false
        this.$emit(event)
      },
      clickOutside() {
        if (!this.show) {
          this.$emit('clickOutside')
        }
        
      }
    }
  }
</script>

<style scoped>
  .title {
    color: #12729a;
    font-weight: 600;
    font-size: 1.5rem;
  }

  .text {
    color: #13445a;
    font-size: 1.125rem;
  }

  .button {
    color: #13445a;
    font-weight: 600;
  }
</style>